import React, { useContext, useEffect, useState } from "react";
import { SiteContext } from "@arcteryx/components-contexts";
import Script from "./Script";
import config from "../config";

// env: production | preprod | stage | qa
const TagManagerScript = ({ env, ...props }) => {
  const [disableAdobeLaunch, setDisableAdobeLaunch] = useState(true);

  // Get URL query param in useEffect, which will only execute on client side
  // This resolves the error of "window not defined" during SSR
  useEffect(() => {
    const getQueryParam = (queryParam) => {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(queryParam);
    };

    setDisableAdobeLaunch(getQueryParam("disableAdobeLaunch") === "1");
  }, []);

  const { market } = useContext(SiteContext);
  const url = config[env] && config[env].launch[market] ? config[env].launch[market] : null;

  return !disableAdobeLaunch ? <Script url={url} {...props} /> : null;
};

export default TagManagerScript;
